<template>
    <rkm-layout-body title="Lista de alergia / reação adversa">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-alergia-create' })"
                color="primary"
                authorize="store-cadastro-alergia"
            >
                Cadastrar alergia
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/alergia/List'

export default {
    components: { List },
}
</script>